module.exports = __webpack_public_path__ + "e-learning-app/static/img/about.c3b82d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about.png
// module id = xWQz
// module chunks = 1